import { useRef, useState } from "react";
type TitleAndDescriptionBag = {
  title: string;
  description: string;
};
export function usePopupController() {
  const [open, setOpen] = useState(false);
  const [titleAndDescription, setTitleAndDescription] =
    useState<TitleAndDescriptionBag>();
  const timeoutRef = useRef<NodeJS.Timeout>();

  const closePopup = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setTitleAndDescription(undefined);
    setOpen(false);
  };
  const openPopup = ({
    title,
    description,
    timeoutMs,
  }: TitleAndDescriptionBag & {
    timeoutMs: number;
  }) => {
    setTitleAndDescription({
      title,
      description,
    });
    setOpen(true);
    timeoutRef.current = setTimeout(closePopup, timeoutMs);
  };

  return {
    openPopup,
    closePopup,
    open,
    title: titleAndDescription?.title ?? "",
    description: titleAndDescription?.description ?? "",
  };
}
